import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/reset.css";
import "./assets/css/common.css";
import "github-markdown-css";
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import '@/assets/js/rem'

// axios
import Axios from "./Axios"
Vue.prototype.$Axios = Axios

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(mavonEditor);

Vue.directive('title', {
  inserted: function (el) {
    document.title = el.dataset.title
  }
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
